import React, { useState, useEffect } from "react";
import QRCode from "react-qr-code";
import { Box, Typography, Tooltip, CircularProgress } from "@mui/material";
import axios from "axios";

const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;

const QrCodeUploadByDoctor = ({ patientId, orgCode, appMode, facilityName }) => {
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchToken = async () => {
      if (!patientId || !orgCode) return;
      
      setLoading(true);
      try {
        const cleanAxios = axios.create();
        const response = await cleanAxios.post(`${REACT_APP_BACKEND_ROUTE_URL}generate-upload-token/`, {
          patient_id: patientId,
          org_code: orgCode,
          app_mode: appMode,
          facility_name: facilityName
        });
        
        if (response.data?.token) {
          setToken(response.data.token);
        }
      } catch (error) {
        console.error("Error fetching upload token:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchToken();
  }, [patientId, orgCode, appMode, facilityName]);

  // Construct the upload URL
  const baseUrl = window.location.origin;
  const uploadUrl = `${baseUrl}/doctor-upload?token=${encodeURIComponent(token)}`;

  return (
    <Box sx={{ 
      display: "flex", 
      flexDirection: "column", 
      alignItems: "center", 
      justifyContent: "center",
      padding: "8px",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      backgroundColor: "#fff",
      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
      maxWidth: "220px",
      margin: "0 0 0 auto",
      minHeight: "220px"
    }}>
      {loading ? (
        <CircularProgress size={24} sx={{ my: 2 }} />
      ) : (
        <>
          <Tooltip title="Scan to upload photos from your phone" arrow>
            <Box sx={{ bgcolor: "#fff", p: 0.5, borderRadius: "4px" }}>
              {token ? (
                <QRCode
                  value={uploadUrl}
                  size={180}
                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                  viewBox={`0 0 256 256`}
                />
              ) : (
                <Box sx={{ height: 180, width: 180, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
                  <Typography variant="caption" sx={{ fontSize: '0.5rem', textAlign: 'center' }}>Error loading QR</Typography>
                </Box>
              )}
            </Box>
          </Tooltip>
          <Typography variant="caption" sx={{ mt: 0.5, fontWeight: 700, fontSize: "0.65rem", color: "#1a2d5e", textAlign: "center" }}>
            SCAN TO UPLOAD
          </Typography>
        </>
      )}
    </Box>
  );
};

export default QrCodeUploadByDoctor;

